type subjectType = 'listen' |'read' |'write'

interface globalI {
  subject: subjectType;
  getWebSocketUrl: ()=>string;
}

const global: globalI = {
  subject: 'listen', // 'listen' 'read' 'write'
  getWebSocketUrl() {
    if (this.subject=== 'listen') {
      return '/ws/simulate-exam/listening-ai-helper';
    } else if (this.subject === 'read') {
      return '/ws/simulate-exam/reading-ai-helper';
    } else if (this.subject === 'write') {
      return '/ws/simulate-exam/writing-inquiry-evaluation';
    } 
    return '';
  }
};

export default global;

